module.exports = __webpack_public_path__ + "img/Comic02-1.86c8acd1.png";